import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Reveal from "@/components/Reveal";

const PORTRAIT = "https://customer-assets-v7afamib.emergentagent.net/job_ctrlb-preview/artifacts/f5jqra8t_11.webp";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="about" ref={ref} className="bg-[#09090B] scroll-mt-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-28 sm:py-40">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <motion.div style={{ y }} className="relative">
              <img
                src={PORTRAIT}
                alt="B, founder of CtrlB Consulting"
                data-testid="about-portrait"
                className="w-full aspect-[4/5] object-cover object-top border border-[#F3F0E8]/15 rounded-2xl"
                loading="lazy"
              />
              <span className="absolute -bottom-4 -right-4 w-24 h-24 border border-[#118C4F]/50 rounded-2xl -z-10 hidden sm:block" aria-hidden="true" />
            </motion.div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#F3F0E8]/35 mt-6">
              Founder · CtrlB Consulting
            </p>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-[#CFE9EF]/70">about</p>
              <h2
                data-testid="about-heading"
                className="font-serif-d font-black tracking-tight leading-[1.0] text-5xl sm:text-7xl text-[#F3F0E8] mt-6"
              >
                Hi, I'm <span className="italic font-semibold text-[#CFE9EF]">B.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <div data-testid="about-copy" className="space-y-6 mt-10 max-w-xl">
                <p className="text-base sm:text-lg text-[#F3F0E8]/70 leading-relaxed">
                  I've spent 8+ years working across content, growth, digital
                  and brand building. Today, my work is much more focused.
                </p>
                <p className="text-base sm:text-lg text-[#F3F0E8]/70 leading-relaxed">
                  I help founders, executives and businesses build a stronger
                  presence on LinkedIn through positioning, content, creative
                  and growth.
                </p>
                <p className="text-base sm:text-lg text-[#F3F0E8]/70 leading-relaxed">
                  CtrlB is the independent consultancy I built around that
                  focus. The work is white-glove by design: a small roster of
                  clients, strategy I lead personally, and a presence built
                  with the care your expertise deserves.
                </p>
                <p data-testid="about-registration" className="text-xs uppercase tracking-[0.25em] text-[#F3F0E8]/40 pt-2">
                  Government of India registered business
                </p>
                <a
                  href="#experience"
                  data-testid="about-background-link"
                  className="inline-block text-sm text-[#118C4F] hover:text-[#CFE9EF] underline underline-offset-4 transition-colors pt-2"
                >
                  See the background behind it ↓
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
